class ClickHelpers {
  static stopPropagation(event: React.SyntheticEvent) {
    event.stopPropagation();
  }
}
export default ClickHelpers;
